export default __webpack_public_path__ + "static/TRACTOCAMIONES-e7bf808366fe5aa256e7a3e493c90d30.jpg";